module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_vm._t("header", [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.subTitle))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "content table-responsive table-full-width",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table",
    class: _vm.tableClass
  }, [_c('thead', _vm._l((_vm.columnsNames), function(name) {
    return (_vm.checkAmountPermission(name)) ? _c('th', {
      staticClass: "text-center"
    }, [_vm._v("\n                " + _vm._s(name) + "\n            ")]) : _vm._e()
  }), 0), _vm._v(" "), _c('tbody', {
    staticClass: "text-center"
  }, [_vm._l((_vm.data), function(item) {
    return _c('tr', _vm._l((_vm.columns), function(column) {
      return (_vm.hasValue(item, column) && _vm.checkAmountPermission(column)) ? _c('td', {
        class: {
          'text-right': column == 'amount'
        }
      }, [_vm._v(_vm._s(column == 'amount' ?
        _vm.numberFormatter(_vm.itemValue(item, column)) :
        _vm.numberFormatterThousand(_vm.itemValue(item, column))) + "\n                ")]) : _vm._e()
    }), 0)
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Suma")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("thousandSep")(_vm.sum.download)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("thousandSep")(_vm.sum.first)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("thousandSep")(_vm.sum.strong)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("thousandSep")(_vm.sum.fills)))]), _vm._v(" "), (!_vm.getPermission('hideAmounts')) ? _c('td', {
    staticClass: "text-right",
    class: {
      'bigAmountSize': _vm.sum.amount > 1000000
    }
  }, [_vm._v(_vm._s(_vm._f("filter")(_vm.sum.amount)))]) : _vm._e()])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2354b48d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/DownloadTable.vue
// module id = 437
// module chunks = 1